import React from "react";
import { LiaArrowRightSolid } from "react-icons/lia";
import styles from "./PromoModal.module.css";

function PromoModal({ isOpen, onClose, onPrimaryAction }) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.overlay} role="presentation" onClick={onClose}>
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-label="Спеціальна пропозиція"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          className={styles.closeButton}
          type="button"
          aria-label="Закрити"
          onClick={onClose}
        >
          ×
        </button>
        <p className={styles.badge}>Чинні пропозиції</p>
        <h3>Перегляньте акційні пропозиції для ваших улюбленців</h3>
        <p>
          Перейдіть в каталог акцій і зберіть кошик із найкращими пропозиціями
          для ваших улюбленців.
        </p>
        <button className={styles.primaryButton} type="button" onClick={onPrimaryAction}>
          Перейти до знижок <LiaArrowRightSolid />
        </button>
      </div>
    </div>
  );
}

export default PromoModal;
